import React, { useMemo } from "react";
import { Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../starek.css";

function FavReportsListingView({
    items,
    selectedRows,
    onSelectedRowsChange,
    filterText,
    onRun,
    isDeleting,
}) {
    const isReportSelected = (reportId) => {
        return selectedRows.some((row) => row.id === reportId);
    };

    const handleCheckboxChange = (report) => {
        let newSelectedRows;
        if (isReportSelected(report.id)) {
            newSelectedRows = selectedRows.filter(
                (row) => row.id !== report.id
            );
        } else {
            newSelectedRows = [...selectedRows, report];
        }
        if (onSelectedRowsChange) {
            onSelectedRowsChange({ selectedRows: newSelectedRows });
        }
    };

    const filteredItems = useMemo(() => {
        const q = filterText?.trim().toLowerCase();
        if (!q) return items;
        return items.filter(
            (item) =>
                item.name?.toLowerCase().includes(q) ||
                item.description?.toLowerCase().includes(q)
        );
    }, [items, filterText]);

    const columns = [
        {
            name: (
                <input
                    type="checkbox"
                    aria-label="Select all"
                    onChange={(e) => {
                        if (e.target.checked) {
                            if (onSelectedRowsChange) {
                                onSelectedRowsChange({
                                    selectedRows: [...filteredItems],
                                });
                            }
                        } else {
                            if (onSelectedRowsChange) {
                                onSelectedRowsChange({ selectedRows: [] });
                            }
                        }
                    }}
                    checked={
                        filteredItems.length > 0 &&
                        filteredItems.every((row) => isReportSelected(row.id))
                    }
                    ref={(el) => {
                        if (!el) return;
                        const some = filteredItems.some((r) =>
                            isReportSelected(r.id)
                        );
                        const all =
                            filteredItems.length > 0 &&
                            filteredItems.every((r) => isReportSelected(r.id));
                        el.indeterminate = some && !all;
                    }}
                />
            ),
            width: "60px",
            center: true,
            sortable: false,
            cell: (row) => (
                <input
                    type="checkbox"
                    checked={isReportSelected(row.id)}
                    onChange={() => handleCheckboxChange(row)}
                    aria-label={`Select ${row.name}`}
                />
            ),
            ignoreRowClick: true,
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            grow: 2,
        },
        {
            name: "Description",
            selector: (row) => row.description,
            sortable: true,
            wrap: true,
            grow: 4,
        },
        {
            name: "Actions",
            cell: (row) => (
                <Button
                    variant="primary"
                    size="sm"
                    onClick={() => onRun(row)}
                    disabled={isDeleting}
                    style={{ whiteSpace: "nowrap" }}
                >
                    <i className="fa fa-play mr-2" />
                    Run
                </Button>
            ),
            width: "160px",
            center: true,
        },
    ];

    return (
        <DataTable
            columns={columns}
            data={filteredItems}
            highlightOnHover
            striped
            responsive
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[5, 10, 20]}
            dense
        />
    );
}

export default FavReportsListingView;
